import { InputLabel, makeStyles } from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import { FormControl, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import {
  AddTransactionCall,
  DeleteTransactionCall,
  GetPackagesCall,
  GetTransactionCall,
} from "../redux/api/transaction.api";
import MDBox from "./MDBox";
import MDButton from "./MDButton";
import moment from "moment";
import parse from "html-react-parser";

const AddTransactionDrawer = ({ lang = "en", open, toggleDrawer, user_id }) => {
  const [packages, setPackages] = useState([]);
  const [selectedPK, setSelectedPK] = useState({});
  const [transactions, setTransactions] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    fetchAPI();
  }, [user_id]);

  console.log("pippo pg  selectedPK", selectedPK);

  const classes = useStyles();

  const onPressSave = async () => {
    setShowLoader(true);
    await AddTransactionCall({
      package_id: selectedPK.id,
      transaction_id: "ios-tr",
      discount_code: null,
      price: selectedPK.price,
      user_id,
    });
    await fetchAPI();
    setSelectedPK([]);
    setShowLoader(false);
  };

  const onPressSelected = (item) => {
    const checkImg = `<img src="https://core.microlab.help/storage/slides/1752833300943-check.png" 
    style="height: 12px; width: 12px; vertical-align: middle; margin-right: 8px;" />`;
    const redCrossImg = `<img src="https://core.microlab.help/storage/slides/1752838679393-cross_red3.png" 
    style="height: 12px; width: 12px; vertical-align: middle; margin-right: 8px;" />`;

    const modifiedDesc = item?.description
      ?.replaceAll("${checkImg}", checkImg)
      ?.replaceAll("${redCross}", redCrossImg)
      ?.replaceAll(
        "<p style=",
        `<p style="font-size:10!important; color=#000000 !important;
        )}px; color:#000000 !important; margin-bottom:4px;`
      );

    const selectedHtml = item
      ? `
    <span style={{ color: 'black' }}>
      ${modifiedDesc}
    </span>
    `
      : "";

    item.description = selectedHtml;
    console.log("pippo itm", item);

    setSelectedPK(item);
  };
  const onPressDelete = async (item) => {
    console.log("pippo ite,", item);
    if (window.confirm("Are you sure you want to delete this transaction?")) {
      await DeleteTransactionCall({
        id: item?.id,
      });
    }
    fetchAPI();
  };
  const fetchAPI = async () => {
    const res_transactions = await GetTransactionCall(lang, user_id);
    const res_packages = await GetPackagesCall(lang);
    setPackages(res_packages?.data ?? []);
    setTransactions(res_transactions?.data ?? []);
  };
  return (
    <Drawer
      className={classes.drawer}
      variant="temporary"
      anchor="right"
      open={open}
      onClose={() => toggleDrawer(false)}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <div className={classes.list}>
        <MDBox component="form" role="form">
          <MDBox mb={2}>
            <FormControl style={{ width: 250, marginTop: 50 }}>
              <InputLabel>Select a package</InputLabel>
              <Select
                value={selectedPK?.id}
                onChange={(e) => onPressSelected(e.target.value)}
                style={{ height: 50, marginTop: 10 }}
              >
                {packages?.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item}>
                      {item?.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <InputLabel style={{ fontSize: 18, marginTop: 20, fontWeight: "bold" }}>
              {selectedPK?.package_title}
            </InputLabel>
            <InputLabel style={{ marginTop: 10, fontWeight: "600" }}>{selectedPK?.name}</InputLabel>
            {selectedPK?.description && (
              <div style={{ marginTop: 10 }}>
                {parse(`<p style="font-size:12px; color='white'">${selectedPK?.description}</p>`)}
              </div>
            )}
          </MDBox>
        </MDBox>

        {transactions.length > 0 && (
          <div style={{ marginTop: 30 }}>
            <h4 style={{ marginBottom: 10 }}>Transactions</h4>
            <div style={{ maxHeight: 700, overflowY: "auto" }}>
              {transactions.map((tx, idx) => (
                <div
                  key={tx.id}
                  style={{
                    marginBottom: 10,
                    padding: 10,
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: 5,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <div>
                      <strong>ID:</strong> {tx.transaction_id}
                    </div>
                    <div>
                      <strong>Transaction Date:</strong>{" "}
                      {moment(tx.created_at)?.format("YYYY/MM/DD")}
                    </div>
                    <div>
                      <strong>Price:</strong> €{tx.price}
                    </div>
                    <div style={{ fontSize: 12, color: "#777" }}>
                      {new Date(tx.created_at).toLocaleString()}
                    </div>
                  </div>
                  <MDButton
                    color="error"
                    variant="outlined"
                    size="small"
                    onClick={() => onPressDelete(tx)}
                    style={{ marginLeft: 10, height: 36 }}
                  >
                    Delete
                  </MDButton>
                </div>
              ))}
            </div>
          </div>
        )}

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <MDButton
            disabled={!selectedPK}
            style={{ width: "100%", marginTop: 20 }}
            color="info"
            variant="contained"
            onClick={() => onPressSave()}
          >
            Save
          </MDButton>
          {/* <MDButton
            disabled={!pack?.id}
            style={{ marginTop: 20 }}
            color="error"
            variant="contained"
            onClick={() => onPressDelete()}
          >
            Delete
          </MDButton> */}
        </div>
      </div>
    </Drawer>
  );
};

export default AddTransactionDrawer;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: "300px",
    flexShrink: 0,
  },
  drawerPaper: {
    width: "300px",
    backgroundColor: "#f5f5f5",
    marginHorizontal: 20,
  },
  toolbar: theme.mixins.toolbar,
  list: {
    margin: "0 20px",
  },
}));
